var raf = require('./raf')

export default function Animate(start, end, animCb, options) {
	if(!(this instanceof Animate)) {
		return new Animate(start, end, animCb, options)
	}

	var opts = this.options = options || {}

	opts.duration = opts.duration || 500
	opts.ease = opts.ease || (a => a * a * a)

	var diff = end - start
	var startTime = null

	var thiz = this

	function anim(curTime) {
		if(null === startTime) {
			startTime = curTime
		}

		var b = (curTime - startTime) / opts.duration

		if(1.0 < b) {
			b = 1.0
		}

		animCb(start + diff * opts.ease(b))

		if(1.0 !== b) {
			thiz.animationId = raf(anim)
		} else {
			thiz.cancel()
		}
	}

	this.animationId = raf(anim)
}

Animate.prototype.cancel = function cancel() {
	if(this.animationId) {
		raf.cancel(this.animationId)
		this.animationId = null
	}

	if(this.options.onEnd) {
		this.options.onEnd()
		this.options.onEnd = null
	}
}
